<template lang="html">
  <div class="row col-xs no-margin no-padding between-xs middle-xs">
    <div class="filter-bar">
      <div class="flex middle-xs">
        <span class="f4 fw4">From </span>
        <span class="search-date-picker">
          <flat-pickr
            class="filter-date-picker"
            v-model="min_date"
            :config="config"
            placeholder="Select a date"
            style="color: #000;"
          ></flat-pickr>

          <a class="input-button clickable" data-toggle>
            <i
              class="fa fa-caret-down"
              style="font-size: 16px; color: #000; margin-right: 20px;"
            />
          </a>
        </span>
        <span class="f4 fw4"> to </span>
        <span class="search-date-picker">
          <flat-pickr
            class="filter-date-picker"
            v-model="max_date"
            :config="config"
            placeholder="Select a date"
            style="color: #000;"
          ></flat-pickr>
          <a class="input-button clickable" data-toggle>
            <i class="fa fa-caret-down" style="font-size: 16px; color: #000;" />
          </a>
        </span>
        <pl-button
          class="pl-primary search-button"
          style="margin: 2px 10px; width: 150px;"
          @click.native="searchAnalytics"
        >
          SEARCH
        </pl-button>
      </div>
      <div class="last-updated">(last updated {{ latest_update }})</div>
      <div v-if="message_error">
        <span class="red">
          Please check selected dates. End date must be greater than begin date
          and date interval must be less than two years.</span
        >
      </div>
    </div>
    <div class="row col-xs end-xs middle-xs">
      <toggle-button
        :sync="true"
        :labels="true"
        @change="handleTrialTeachers($event)"
        :value="trial_teachers_active"
        color="#72ccd7"
      />
      <span
        class="ml2 fw4 trial-teacher-span"
        @click="trial_teachers_modal = true"
      >
        Trial Teachers
      </span>
    </div>
    <div v-if="trial_teachers_modal">
      <trial-teachers-modal
        @close="trial_teachers_modal = false"
        @searchAnalytics="searchAnalytics"
      />
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import flatPickr from 'vue-flatpickr-component';
  import Multiselect from 'vue-multiselect';
  import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
  import trialTeachersModal from './trialTeachersModal';
  import adminServices from 'services/admin/adminServices';
  //import moment from 'moment';
  export default {
    data() {
      return {
        min_date: null,
        max_date: null,
        config: {
          wrap: true,
          plugins: [
            new monthSelectPlugin({
              shorthand: true,
              dateFormat: 'F Y',
              altFormat: 'F  Y',
            }),
          ],
        },
        message_error: '',
        trial_teachers_modal: false,
        trial_teachers: [],
        latest_update: '',
      };
    },
    components: {
      flatPickr,
      Multiselect,
      trialTeachersModal,
    },
    props: {
      systemWideData: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    computed: {
      ...mapGetters(['getCurrentSchool']),
      trial_teachers_active() {
        return this.getCurrentSchool.trial_teachers_active;
      },
    },
    methods: {
      searchAnalytics() {
        this.message_error = false;

        const newMinDate = '01 ' + this.min_date;

        const newMaxDate = '01 ' + this.max_date;

        const minDateAux = new Date(newMinDate);

        const minDateString =
          minDateAux.getFullYear() +
          '/' +
          (minDateAux.getMonth() + 1) +
          '/' +
          minDateAux.getDate();

        const minDate = new Date(minDateString);

        const maxDateAux = new Date(newMaxDate);

        const year = maxDateAux.getFullYear();
        const month = maxDateAux.getMonth() + 1;
        const maxDateString =
          year +
          '/' +
          month +
          '/' +
          new Date(year, month, 0).getDate() +
          ' 23:59:59';

        const maxDate = new Date(maxDateString);

        const differenceInYears = (maxDate - minDate) / 31556952000;

        if (minDate < maxDate && differenceInYears < 2.0) {
          this.$emit('date_filter', {
            begin_date: minDateString,
            end_date: maxDateString,
          });
        } else {
          this.message_error = true;
        }
      },
      handleTrialTeachers(event) {
        adminServices
          .editSchool(this.$route.params.schoolID, {
            trial_teachers_active: event.value ? true : false,
          })
          .then(({ data }) => {
            this.$store.dispatch('updateSchoolDetails', data);
            this.searchAnalytics();
          });
      },
      getLatestDateUpdate() {
        adminServices
          .getLatestDateUpdate()
          .then(({ data: { end_date: end_date_string } }) => {
            const end_date = new Date(end_date_string);

            const day = end_date.toLocaleDateString();

            const time = end_date.toLocaleTimeString();

            this.latest_update = `${day} at ${time}`;
          });
      },
    },
    mounted() {
      const current_month = new Date().getMonth() + 1;
      if (current_month >= 8) {
        this.min_date = 'August ' + new Date().getFullYear();
        this.max_date = 'July ' + (new Date().getFullYear() + 1);
      } else {
        this.min_date = 'August ' + (new Date().getFullYear() - 1);
        this.max_date = 'July ' + new Date().getFullYear();
      }
      this.searchAnalytics();
      this.getLatestDateUpdate();
    },
  };
</script>
<style lang="stylus" scoped>
  .filter-bar
    font-size: 16px
  .flatpickr-input
    text-align: center
    font-weight: 600
    text-decoration: underline
    max-width: 145px
  .search-button
    width: 150px
    margin-left: 20px
  .trial-teacher-span
    color: #797979
    &:hover
      cursor: pointer
      text-decoration: underline
  .last-updated
    line-height: 13px
    font-size: 11px
    font-style: italic
</style>
<style src="flatpickr/dist/plugins/monthSelect/style.css"></style>



// WEBPACK FOOTER //
// adminPortalAnalyticsFiltersBar.vue?2fb870c8